import DemandStudioPreviewClientSelect from '../demand-studio/DemandStudioPreviewClientSelect';

// inline-flex bounds the XSelect width so it does not stretch the header row
const wrapClasses = 'inline-flex items-center';

const LifecareStudioClientSelector = ({
  lifecareClientIdAndDisplayNames,
  selectedClientId,
  setSelectedClientId,
}) => {
  if (lifecareClientIdAndDisplayNames.length <= 1) return null;
  const options = lifecareClientIdAndDisplayNames.map(({ clientId, clientDisplayName }) => ({
    value: clientId,
    text: clientDisplayName,
  }));
  return (
    <div className={wrapClasses}>
      <DemandStudioPreviewClientSelect
        options={options}
        selectedClientId={selectedClientId}
        onSelectClient={({ value }) => setSelectedClientId(value)}
        variant="header"
      />
    </div>
  );
};

export default LifecareStudioClientSelector;
